"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parameter = void 0;
var Parameter;
(function (Parameter) {
    Parameter["After"] = "after";
    Parameter["Limit"] = "limit";
    Parameter["Username"] = "username";
    Parameter["Period"] = "period";
    Parameter["Metric"] = "metric";
})(Parameter = exports.Parameter || (exports.Parameter = {}));
//# sourceMappingURL=parameters.enum.js.map